import { securityAuthenticationServices } from "./authentication";

export const securityServices = {
  securityAuthenticationServices
};